import { render, staticRenderFns } from "./serviciosCliBarragan.vue?vue&type=template&id=657887d8&scoped=true&"
import script from "./serviciosCliBarragan.vue?vue&type=script&lang=js&"
export * from "./serviciosCliBarragan.vue?vue&type=script&lang=js&"
import style0 from "./serviciosCliBarragan.vue?vue&type=style&index=0&id=657887d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657887d8",
  null
  
)

export default component.exports